import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import { useIntl } from 'react-intl';
import { applyFormat, FormatKind } from './commentMarkdown';

interface CommentFormatToolbarProps {
  textareaRef: React.RefObject<HTMLTextAreaElement | HTMLInputElement | null>;
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}

function CommentFormatToolbar({
  textareaRef,
  value,
  onChange,
  disabled
}: CommentFormatToolbarProps) {
  const intl = useIntl();

  const handle = (kind: FormatKind) => () => {
    applyFormat(textareaRef.current, value, kind, onChange);
  };

  const btnSx = { minWidth: 32, px: 1, py: 0.25, fontSize: 12, textTransform: 'none' as const };

  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
      <Tooltip title={intl.formatMessage({ id: 'commentFormatBold', defaultMessage: 'Bold' })}>
        <span>
          <Button size="small" variant="outlined" sx={btnSx} onClick={handle('bold')} disabled={disabled}>
            <FormatBoldIcon fontSize="inherit" />
          </Button>
        </span>
      </Tooltip>
      <Tooltip title={intl.formatMessage({ id: 'commentFormatH1', defaultMessage: 'Heading 1' })}>
        <span>
          <Button size="small" variant="outlined" sx={btnSx} onClick={handle('h1')} disabled={disabled}>
            H1
          </Button>
        </span>
      </Tooltip>
      <Tooltip title={intl.formatMessage({ id: 'commentFormatH2', defaultMessage: 'Heading 2' })}>
        <span>
          <Button size="small" variant="outlined" sx={btnSx} onClick={handle('h2')} disabled={disabled}>
            H2
          </Button>
        </span>
      </Tooltip>
      <Tooltip title={intl.formatMessage({ id: 'commentFormatH3', defaultMessage: 'Heading 3' })}>
        <span>
          <Button size="small" variant="outlined" sx={btnSx} onClick={handle('h3')} disabled={disabled}>
            H3
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}

export default CommentFormatToolbar;
